import { BottomSheet } from 'components/Toolkit/BottomSheet/BottomSheet';
import { Button } from 'components/Toolkit/Button';
import { FiltersV2 } from 'features/filters/FiltersV2';
import { useFilterBottomSheet } from 'components/SearchPage/features/QuickFilters/components/FilterBottomSheet/FilterBottomSheet.hook';
import { useQuickFilterContext } from 'components/SearchPage/features/QuickFilters/QuickFilters.context';
import * as Styled from 'components/SearchPage/features/QuickFilters/components/FilterBottomSheet/FilterBottomSheet.styled';
import type { FilterDisplayProps } from 'components/SearchPage/features/QuickFilters/components/FilterBottomSheet/FilterBottomSheet.typed';
import { Spacer } from 'helpers/genericStyles';

const FilterDisplay = (props: FilterDisplayProps) => {
  const { sectionName } = props;
  const {
    currentFilter,
    isFilterBottomSheetOpen: isOpen,
    onCloseFilterDisplay: askToClose,
  } = useQuickFilterContext();

  const {
    onClickDone,
    onClickClear,
    onChange,
    value,
    locationConfiguration,
    makeModelConfiguration,
    appliedFilterID,
    validPriceConfiguration,
  } = useFilterBottomSheet({
    askToClose,
  });

  return (
    <BottomSheet
      headerText={currentFilter?.displayName ?? ''}
      askToClose={askToClose}
      isOpen={isOpen}
      height=""
      variant="DIALOG"
    >
      {currentFilter && (
        <FiltersV2
          filter={{
            ...currentFilter,
            displayName: '',
            onChange,
            value,
          }}
          locationConfiguration={locationConfiguration}
          makeModelConfiguration={makeModelConfiguration}
          validPriceConfiguration={validPriceConfiguration}
          sectionName={sectionName}
        />
      )}
      <Spacer marginBottom={'M16'} />
      <Styled.ButtonContainer>
        <Button ofType="SECONDARY" onClick={onClickClear}>
          Clear
        </Button>
        <Button
          onClick={onClickDone}
          data-tracking={appliedFilterID}
          data-testid={'quick-filter-done'}
        >
          Done
        </Button>
      </Styled.ButtonContainer>
    </BottomSheet>
  );
};

export { FilterDisplay };
